import React, { Component } from 'react';
import CardComponent from '@kurtosys/ksys-app-components/dist/components/base/Card';
import {
	ICardProps,
	ICardState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';

@inject('appStore', 'cardStore')
@observer
export class Card extends Component<ICardProps, ICardState> {
	static configurationKey: 'card' = 'card';
	static styleKey: 'card' = 'card';
	constructor(props: ICardProps) {
		super(props);
	}
	render() {
		const { className, cardStore, children } = this.props;

		if (!cardStore) {
			return null;
		}

		const { props } = cardStore;

		return (
			<Wrapper className={ className }>
				<CardComponent { ...props }>
					{ children }
				</CardComponent>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Card, 'card');

